import Button from "@mui/material/Button";

export const RefreshButton = (props) => {
  return (
    <Button
      {...props}
      sx={{
        marginTop: "0rem",
        padding: "0.25rem 0.75rem",
        backgroundColor: "transparent",
        minWidth: 0,
        color: "var(--primary)",
        fontSize: "1rem",
        fontWeight: 600,
        lineHeight: "1.5rem",
        height: "35px",
        width: "122px",
        whiteSpace: "nowrap",
        border: "1px solid",
        "&:hover": {
          backgroundColor: "#2A3467",
          color: "#FFFFFF",
          border: "1px solid rgb(14, 20, 51)",

        },
      }}
    >
      {props.children}
    </Button>
  );
};
